import packageJson from '../../package.json';
import { apiSetting } from './connections/connections.env';
import { GoogleConnections } from './connections/google.connections';

const appEnv = process.env.APP_ENV;

const key = {
  GOOGLE_ANALYTICS: process.env.GOOGLE_ANALYTICS,
  GW_APP_KEY: process.env.GW_APP_KEY,
  GM_KEY: process.env.GM_KEY,
  FIREBASE_API_KEY: process.env.FIREBASE_API_KEY,
};

const KEYCLOAK_CONFIG = {
  url: process.env.IAM_URL,
  realm: process.env.IAM_REALM,
  clientId: process.env.IAM_CLIENT_ID,
};

const externalUrls = {
  terminalPanel: process.env.EXTERNAL_URL_TERMINAL_PANEL,
  managementPanel: process.env.EXTERNAL_URL_MANAGEMENT_PANEL,
  tratoResponde: process.env.EXTERNAL_URL_TRATO_RESPONDE,
};

const connections = new GoogleConnections();
const DEFAULT_SIZE_REQUEST = 20;
const API = apiSetting(process.env.API_URL);
const googleSettings = connections.googleSettings(key);
const firebaseSettings = connections.firebaseSettings(key, appEnv);

export const environment = {
  production: appEnv === 'PRD',
  API,
  googleSettings,
  firebaseSettings,
  DEFAULT_SIZE_REQUEST,
  KEYCLOAK_CONFIG,
  version: packageJson.version,
  blipAppKey: process.env.BLIP_APP_KEY,
  cryptoKey: process.env.CRYPTO_KEY,
  externalUrls,
};
